import { withUpdatedTheme } from 'src/components/theme';

import { Container as ContainerComponent, ContainerProps } from './container';
import { defaultContainerStyles } from './default-container-styles';
import { largeContainerStyles } from './large-container-styles';
import { smallContainerStyles } from './small-container-styles';

export const SmallContainer = withUpdatedTheme<ContainerProps>({
  container: smallContainerStyles,
})(ContainerComponent);
export const LargeContainer = withUpdatedTheme<ContainerProps>({
  container: largeContainerStyles,
})(ContainerComponent);
export const Container = withUpdatedTheme<ContainerProps>({
  container: defaultContainerStyles,
})(ContainerComponent);
